import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as InstallationDashboardsActions from '../actions/installationDashboards.actions';
import { catchError, exhaustMap, first, map, switchMap, tap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import {InstallationDashboardService} from '../../../core/services/installation-dashboard.service';
import { Store } from '@ngrx/store';

@Injectable()
export class InstallationDashboardsEffects {

  getInstallationDashboardsByUnitId$ = createEffect(() =>
    this._actions$.pipe(
      ofType(InstallationDashboardsActions.getInstallationDashboardsByUnitId.type),
      switchMap((action: any) => {
        const subs = [];
        action?.unitIds?.forEach(unitId => subs.push(this._installationDashboardService.getInstallationDashboardsByUnitId(unitId).pipe(
          first(),
          map(data => !!data ? data : []),
          catchError(err => of(err?.data)),
        )));
        return forkJoin(subs).pipe(
          exhaustMap((data) => {
            const map = new Map<number, any>();
            action?.unitIds?.forEach((unitId: number, index: number) => map.set(unitId, data[index]));
            return of(InstallationDashboardsActions.getInstallationDashboardsByUnitIdSuccess({data: map}));
          }),
          catchError(error => {
            return of(InstallationDashboardsActions.getInstallationDashboardsByUnitIdFailure({error}))
          })
        );
      })
    )
  );

  constructor(
    private _actions$: Actions,
    private _store$: Store<any>,
    private _installationDashboardService: InstallationDashboardService
  ) { }
}
